package one.healthium.paywall.ui.components

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.util.fastForEach
import one.healthium.domain.common.Animations
import one.healthium.domain.paywall.models.PaywallPurchaseButtonView
import one.healthium.ui.components.CtaButton

@Composable
fun PaywallPurchaseButtonView(
    model: PaywallPurchaseButtonView,
    animations: Animations?,
    onClick: () -> Unit,
) {
    CtaButton(
        modifier = Modifier.padding(horizontal = 24.dp),
        onClick = onClick,
        animations = animations,
        ctaConfig = model.config.ctaConfig,
    ) {
        Column(
            modifier = Modifier.fillMaxWidth(),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            model.config.attributedLines.fastForEach { attributedLine ->
                AttributedLine(
                    lineModel = attributedLine,
                    product = null
                )
            }
        }
    }
}
